import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize18, lineHeightTight, fontWeightSemiBold } from "@churchofjesuschrist/eden-style-constants";
export const internalUseOnlyPriority4 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightSemiBold, fontSize18, lineHeightTight);
const H4Styled = styled.h4.withConfig({
  componentId: "sc-12mz36o-0"
})(["", ";"], internalUseOnlyPriority4);

const H4 = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(H4Styled, props, children);
};

export default H4;
H4.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired
};